<template>
  <div class="columns is-multiline">
    <div class="column is-half" v-for="(item, index) in items" :key="index">
      <article class="media">
        <figure class="media-left">
          <p class="image is-64x64">
            <img src="/static/img/logo-mini.svg">
          </p>
        </figure>
        <div class="media-content">
          <div class="content">
            <p v-html="item"></p>
          </div>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/SectionBullets.vue